import {
  observable,
  action
} from 'mobx'
import { convertTask, convertUpload, convertChangeResult } from '@api/fwApi/webpdfapi';
import getStream from './getStream';
import {store} from 'Store/store.index';
import { getUserInfo } from "Api/fwApi/login"
import utils from "@foxit/utils";

export default class convert extends getStream {
  @observable isShowFwConvertModal = false;
  @observable isShowFwConvertImgType = false;
  @observable convertType = "convert-to-pdf";
  @observable convertPdfFileName = "";
  @observable convertUrlFile = "";
  @observable MIMEType = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"];
  @observable convertOpenFile = ""; // 转pdf的文件
  @observable toPdfConvertOpenFile = false; // 直接转pdf打开文件标识

  @action getIsShowFwConvertModal(isShowFwConvertModal){
    this.isShowFwConvertModal = isShowFwConvertModal
  }
  @action getIsShowFwConvertImgType(isShowFwConvertImgType){
    this.isShowFwConvertImgType = isShowFwConvertImgType
  }
  @action getConvertType(convertType){
    this.convertType = convertType
  }
  @action getConvertPdfFileName(convertPdfFileName){
    this.convertPdfFileName = convertPdfFileName
  }
  @action getConvertUrlFile(convertUrlFile){
    this.convertUrlFile = convertUrlFile
  }
  // 轉pdf展示
  @action getToPdfConvertOpenFile(toPdfConvertOpenFile) {
    this.toPdfConvertOpenFile = toPdfConvertOpenFile
  }
  // 打開的文件的數據 bold
  @action getConvertOpenFile(convertOpenFile){
    this.convertOpenFile = convertOpenFile
  }
  /**
   * 获取当前文件文件流
   * @param {*} fileName 文件名
   * @returns 
   */
  @action fileToBlob(fileName) {
    return new Promise((resolve, reject)=>{
      this.getFileBlob().then(blob => {
        this.postConvertUpload(blob, fileName).then(res=>{
          resolve(res)
        },err=>{
          reject(err)
        });
      });
    })
  }
  /**
   * 上传转换文件
   * @param {*} fileName 文件名
   * @param {*} blob 文件流
   * @returns 
   */
  @action postConvertUpload(blob, fileName) {
    console.log("postConvertUpload")
    console.log(blob)
    let formData = new FormData();
    formData.append("file", blob, fileName);
    const config = {
      headers: {
        "Content-Type": `multipart/form-data;boundary=${new Date().getTime()}`
      },
      params: formData,
      timeout:1000000
    };
    return new Promise((resolve, reject)=>{
      convertUpload(config).then(res=>{
        resolve(res);
      },err=>{
        reject(err)
      })
    })
  }
  /**
   * 转换文件
   * @param {*} docId 文档id
   * @param {*} taskName 转换类型名称
   * @returns 
   */
  @action postConvertTask(docId, taskName) {
    let formData = new FormData();
    formData.append("docId", docId);
    formData.append("taskName", taskName);
    const config = {
      headers: {
        "Content-Type": `multipart/form-data;boundary=${new Date().getTime()}`
      },
      params: formData,
      timeout:1000000
    }
    return new Promise((resolve, reject)=>{
      convertTask(config).then(res=>{
        resolve(res);
      },err=>{
        reject(err)
      })
    })
  }
  /**
   * [文件转换查询结果]
   * @param {*} docId 文档id
   * @param {*} taskId 转换任务id
   */
  @action getConvertChangeResult(docId, taskId) {
    const config = {
      params:{
        docId,
        taskId
      }
    }
    return new Promise((resolve, reject)=>{
      convertChangeResult(config).then(res=>{
        resolve(res);
      },err=>{
        reject(err)
      })
    })
  }

  // 打开非pdf文档，调用转换逻辑
  @action openFileBeforeConvert(file, fileName) {
    /* 
     * 1、判断用户是否登录
     * 2、判断当前登录用户是否vip，有转换权限；非vip，弹出鉴权窗口；
     * 3、判断文件格式，支持word、PPT、excel、image
     * 4、不满足的格式弹出格式不符合弹出。
     * 5、满足格式要求，上传文档，
     */

    const hasSignIn = store.loginNewStore.isLogin
    if(!hasSignIn){
      store.loginNewStore.login()
      return true;
    }
    const config = {
      headers: {
        client: 'editCloud'
      },
      params: {
        token: utils.util.getQueryString("token")
      }
    }
    getUserInfo(config).then(res => {
      if (res.ret === 0) {
        store.userNewStore.setUserInfo(res.data);
        if(res.data.identity === "vip") {
          this.getConvertType("convert-to-pdf");
          store.docsStore.getDocsModalType("convert");
          this.getToPdfConvertOpenFile(true)
          this.getConvertOpenFile(file)
          this.getConvertPdfFileName(fileName);
          this.getIsShowFwConvertModal(true);
        } else {
          store.common.getIsShowOpenMember(true);
        }
      }
    });
  }
}